export default "__VITE_ASSET__GldLzxvf__"